const Data = {
  apiEndPoint: process.env.REACT_APP_API_URL,
  summaryapiEndPoint: process.env.REACT_APP_SUMMARY_API_URL,
  name: process.env.NODE_ENV,
  rootuser: process.env.REACT_APP_ROOT_USER,
  domain: process.env.REACT_APP_EMAIL_DOMAIN,
  form_auth: process.env.REACT_APP_FORM_AUTH === 'yes' || false,
  sso_auth: process.env.REACT_APP_SSO_AUTH === 'yes' || false,
};

export default Data;
